import { chunk, pick } from 'lodash-es';
import { elk, CustomException } from '@tencent/ppd-base-libs';
import { EXCH_ACT_PRIZE_INFO } from '../../config/stamp';
const pickFields = ['couponId',
    'hasGot',
    'userLimit',
    'dayLimit',
    'daySent',
    // 'exchEndTime',
    // 'exchStartTime',
    'totalNum',
    'totalSendNum',
    'userMonthLimit',
    'userMonthSent',
    // 'enCouponid',
    // 'enActid',
];
/** exch_act_prize_info.cgi 的专属上报
 * 因为用base-lib默认的request内容太多了
*/
export const reportExchActPrizeInfoRes = (res, params) => {
    try {
        const cgiName = EXCH_ACT_PRIZE_INFO.split('/').reverse()[0];
        // 正常返回的情况
        if ((res === null || res === void 0 ? void 0 : res.retcode) === '0') {
            const { exchActidList = [], qualExchActidList = [], qualInfoList = [], couponInfoList = [] } = res;
            const exchActInfo = qualExchActidList.length > 0 ? qualExchActidList : exchActidList;
            const targetRes = couponInfoList.map((coupon) => {
                const enExAct = exchActInfo.find(act => act.prizeId === coupon.enCouponid);
                const qualInfo = qualInfoList.find(item => (enExAct === null || enExAct === void 0 ? void 0 : enExAct.enActid) === item.enActid);
                const returnObj = pick(Object.assign(Object.assign(Object.assign({}, coupon), enExAct), qualInfo), pickFields);
                return returnObj;
            });
            const groupRes = chunk(targetRes, 10); // 分组
            const groupId = String(Math.random()).split('.')[1];
            groupRes.forEach((groupItem) => {
                elk({
                    key: cgiName,
                    msg: JSON.stringify(groupItem),
                    str1: groupId,
                    errCode: res.retcode,
                    str4: JSON.stringify(params),
                    str2: 'ajax',
                });
            });
            return;
        }
        // 异常情况
        elk({
            key: cgiName,
            msg: JSON.stringify(res),
            errCode: res === null || res === void 0 ? void 0 : res.retcode,
            str4: JSON.stringify(params),
            str2: 'ajax',
        });
        new CustomException(JSON.stringify(Object.assign({ cgi: cgiName }, res)), 'qryExchActPrizeInfoResFail', '查询奖品接口失败');
        return;
    }
    catch (e) {
        new CustomException(e, 'reportExchActPrizeInfoResFail', '自定义上报查询奖品接口失败');
    }
};
